import { FeatureFlagValue } from '@/common/domain/constants/featureFlags';
import { useFeatureFlags } from './useFeatureFlags';

/**
 * React hook that subscribes to a LaunchDarkly feature flag and returns its current value
 * @param flagKey - The key of the feature flag to subscribe to
 * @param defaultValue - Default value to use if the flag is not defined (defaults to false for boolean flags)
 * @returns The current value of the feature flag
 */
export const useFeatureFlag = <T = boolean>(flagKey: FeatureFlagValue, defaultValue: T = false as T): T => {
  const { values } = useFeatureFlags([flagKey]);
  return (values[flagKey] ?? defaultValue) as T;
};
